const INITIAL_STATE = {
  error: false,
  loading: null,
  data: [],
};

const Medias = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "MEDIAS_REQUEST":
      return { loading: true, error: false, data: [] };
    case "MEDIAS_SUCCESS":
      return { loading: false, error: false, data: action.payload };
    default:
      return state;
  }
};

export default Medias;
